import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'Generale',
    [Tab.SignedLive]: 'Firmati / Attivi',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Commissione',
  },
};
